const title = '10000个有道词典VIP限时赠送'
const desc = '日语学习用有道，领VIP免费查新世纪日汉双解大辞典'
const imgUrl = 'https://oimageb2.ydstatic.com/image?id=2493852103049466641&product=xue'
const signId = ''
import jsonp from 'jsonp'
const ua = navigator.userAgent
const ydk = window.ydk
const isYouDao = ua.indexOf('youdao')
const isYouDaoCourse = ua.indexOf('youdaoCourse')
const isYouDaoDict = ua.indexOf('youdaodict')

export const initShareData = (link, silence) => {
    ydk.share({
        title: title,
        desc: desc,
        link: link,
        imgUrl: imgUrl,
        silence: silence,
        shift: true
    });
}
export const changeURLArg = function (url, arg, arg_val) {
    var pattern = arg + '=([^&]*)';
    var replaceText = arg + '=' + arg_val;
    if (url.match(pattern)) {
        var tmp = '/(' + arg + '=)([^&]*)/gi';
        tmp = url.replace(eval(tmp), replaceText);
        return tmp;
    } else {
        if (url.match('[\?]')) {
            return url + '&' + replaceText;
        } else {
            return url + '?' + replaceText;
        }
    }
    return url + '\n' + arg + '\n' + arg_val;
}

export const setStorage = function (key, value) {
    let v = value;
    if (typeof v == 'object') {
        v = JSON.stringify(v);
        v = 'obj-' + v;
    } else {
        v = 'str-' + v;
    }
    let ls = window.localStorage;
    if (ls) {
        ls.setItem(key, v);
    }
};
//获取缓存
export const getStorage = function (key) {
    let ls = window.localStorage;
    if (ls) {
        let v = ls.getItem(key);
        if (!v) {
            return;
        }
        if (v.indexOf('obj-') === 0) {
            v = v.slice(4);
            return JSON.parse(v);
        } else if (v.indexOf('str-') === 0) {
            return v.slice(4);
        }
    }
};
export const getParameter =  function (name) {
    var r = new RegExp("(\\?|#|&)" + name + "=([^&#]*)(&|#|$)"),
        m = location.href.match(r);
    return decodeURIComponent(!m ? "" : m[2]);
};

export const login = (silence) => {
    ydk.isLogin({
        success: function (res) {
            if (!res.isLogin) {
                if (isYouDao == -1) {
                    window.location.href = 'http://c.youdao.com/dict/commons/login.html?back_url=' + encodeURIComponent(window.location.href)
                } else {
                    ydk.login({
                        defer: 3000,
                        success: function (res) {
                            jsonp('http://webutil.youdao.com/webutil/v2/dictVIP/getEncodedUserId', function (err, data) {
                                let url
                                let signId = data.result.signId
                                if (!ydk.isYD) {
                                    url = changeURLArg(window.location.href, 'signId', signId)
                                } else {
                                    url = changeURLArg('http://c.youdao.com/test/oxford-activity/index.html', 'signId', signId)
                                }
                                initShareData(url, silence)
                            })
                        }
                    })
                }
            } else {
                jsonp('http://webutil.youdao.com/webutil/v2/dictVIP/getEncodedUserId', function (err, data) {
                    let url
                    let signId = data.result.signId
                    if (!ydk.isYD) {
                        url = changeURLArg(window.location.href, 'signId', signId)
                    } else {
                        url = changeURLArg('http://c.youdao.com/test/oxford-activity/index.html', 'signId', signId)
                    }
                    initShareData(url, silence)
                })
            }
        }
    })
}


// WEBPACK FOOTER //
// ./src/libs/util.js